import React, { useState } from "react";
import { handleApiErrors, InputType, validationRegex,} from "../../Utils/Utils";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import CoordinatorSidebar from "../CoordinatorSidebar/CoordinatorSidebar";
import CoordinatorNavbar from "../CoordinatorNavbar/CoordinatorNavbar";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import RoutesPath from "../../Utils/RoutesPath";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import { toast } from "react-toastify";


const CoordinatorChangePassword = ({ show }) => {
  const navigate = useNavigate();
  const schema = yup.object().shape({
    currentPassword: validationRegex.currentPassword,
    newPassword: validationRegex.newPassword,
    confirmPassword: validationRegex.confirmPassword,
  });

  const { register: registerUpdate, handleSubmit: handleSubmitUpdate, formState: { errors: errorsUpdate },reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
  });

  const cochangePassword = async (data) => {
    const { currentPassword, newPassword, confirmPassword } = data;
    try {
      await CoordinatorApiServices.cochangePassword(
        currentPassword,
        newPassword,
        confirmPassword,
      );
      reset();
      toast.success("Your password changed successfully");
      navigate(RoutesPath.dashboardcoordinator); // Redirect to the packages page
    } catch (error) {
      handleApiErrors(error);
    }
  };

  return (
    <div className="d-flex">
    <CoordinatorSidebar />
    <div className="mainLayout-content">
        <CoordinatorNavbar />
        <div className="main_content_two contentSection scroll_bar cofocus">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black sub-large-text-one fw-700 mb-0">Change Password</h1>
          </div>
          <form onSubmit={handleSubmitUpdate(cochangePassword)}>
            <div className="row profile_inputs w-100">
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Current Password"
                  placeholder="Enter Current Password"
                   additionalClasses="profile_edit"
                  inputType={InputType.password}
                    showMandatory={true}
                     labelClass="TextInput"
                     id="currentPassword"
                     name="currentPassword"
                     showError={errorsUpdate?.currentPassword}
                     errorMessage={errorsUpdate?.currentPassword?.message}
                     register={registerUpdate}
                />
              </div>
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="New Password"
                  additionalClasses="profile_edit"
                  labelClass="TextInput"
                  inputType={InputType.password}
                  id="newPassword"
                  name="newPassword"
                  placeholder="Enter New Password"
                  showMandatory={true}
                  showError={errorsUpdate?.newPassword}
                  errorMessage={errorsUpdate?.newPassword?.message}
                  register={registerUpdate}
                />
              </div>
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Confirm Password"
                  inputType={InputType.password}
                  additionalClasses="profile_edit"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Enter Confirm Password"
                  showMandatory={true}
                   labelClass="TextInput"
                   showError={errorsUpdate?.confirmPassword}
                errorMessage={errorsUpdate?.confirmPassword?.message}
                register={registerUpdate}
                />
              </div>
              <div className="d-flex justify-content-end chnagebtnrespo">
              <SubmitButtonTwo title={"Change Password"} className="Changebtn"
              />
            </div>
            </div>
           
          </form>
        </div>
        </div>
        </div>
  );
};

export default CoordinatorChangePassword;

